import React, { Component } from "react";
import NavBar from "../components/NavBar";
import FeatureIcon from "../components/FeatureIcon";
import Funfact from "../components/Funfact";
import TeamMemberGrid from "../components/TeamMemberGrid";
import TestimonialSlider from "../components/TestimonialSlider";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
class About extends Component {


  render() {
    return (
      <div>
        {/* Navigation bar */}
        <NavBar />

        {/* breadcrumb */}
        {/*====================  breadcrumb area ====================*/}
        <div
          className="breadcrumb-area breadcrumb-bg"
          style={{
            backgroundImage: `url(assets/img/backgrounds/funfact-bg.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="page-banner text-center">
                  <h1>About Us</h1>
                  <ul className="page-breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>About Us</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of breadcrumb area  ====================*/}

        <div className="page-wrapper section-space--inner--top--120">
          {/*About section start*/}
          <div className="about-section section-space--inner--bottom--120">
            <div className="container">
              <div className="row row-25 align-items-center">
                <div className="col-lg-6 col-12 mb-30">
                  <div className="about-image-two">
                    <img
                      src="assets/img/about/about-3.jpg"
                      alt="Shakuntla Learn and Fly Foundation"
                      className="img-fluid"
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-12 mb-30">
                  <div className="about-content-two">
                    <h3>Welcome to</h3>
                    <h1>Shakuntla Learn and Fly Foundation</h1>
                    <h4>

                    </h4>
                    <p>
                      Shakuntla Learn and Fly Foundation is a Gurugram-based non-profit
                      organization dedicated to empowering children through education,
                      therapy, and holistic development. We specialize in supporting
                      children with special needs, including Autism Spectrum Disorder,
                      Cerebral Palsy, ADHD, intellectual disabilities, and other
                      developmental challenges.
                      Our mission is to provide quality
                      education, evidence-based therapies, life skills, and inclusive
                      learning opportunities in a safe, nurturing, and supportive
                      environment where every child can thrive.
                    </p>
                    <a
                      href="services"
                      className="ht-btn--default ht-btn--default--dark-hover section-space--top--20"
                    >
                      Our Services
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*About section end*/}

          {/* Feature Icon */}
          <FeatureIcon background="grey-bg" />

          {/*About section start*/}
          <div className="about-section section-space--inner--120">
            <div className="container">
              <div className="about-wrapper row">
                <div className="col-sm-6 col-12 order-1 order-lg-2">
                  <div className="about-image about-image-1">
                    <img src="assets/img/about/about-1.jpg" alt="" />
                  </div>
                </div>
                <div className="col-sm-6 col-12 order-2 order-lg-3">
                  <div className="about-image about-image-2">
                    <img src="assets/img/about/about-2.jpg" alt="" />
                  </div>
                </div>
                <div className="col-lg-6 col-12 order-3 order-lg-1">
                  <div className="about-content about-content-1">
                    <h2>Our Vision</h2>

                    <p>
                      To build an inclusive and empowered society where every child,
                      regardless of ability, has access to quality education, therapy,
                      life skills, and opportunities to reach their full potential and
                      live with dignity, independence, and confidence.
                    </p>
                  </div>
                </div>

                <div className="col-lg-6 col-12 order-4">
                  <div className="about-content about-content-2">
                    <h2>Our Mission</h2>

                    <p>
                      Shakuntla Learn and Fly Foundation is committed to transforming
                      the lives of children with special needs through affordable
                      education, evidence-based therapies, family support, skill
                      development, and community awareness. We strive to create
                      inclusive learning environments, foster independence, promote
                      social acceptance, and prepare children for meaningful
                      participation in society and future employment opportunities.
                    </p>

                    <a
                      href={`${process.env.PUBLIC_URL}/contact-us`}
                      className="ht-btn--default ht-btn--default--dark-hover section-space--top--20"
                    >
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*About section end*/}

          {/* Fun fact */}
          <Funfact />

          {/* Team member */}
          <TeamMemberGrid />

          {/* Testimonial Slider */}
          <TestimonialSlider />

        </div>

        {/* Footer */}
        <Footer />

        {/* Mobile Menu */}
        <MobileMenu />
      </div>
    );
  }
}

export default About;
